module.exports = __webpack_public_path__ + "static/reward-success-tip.7c62c7ce.svg";